module.exports = __webpack_public_path__ + "static/media/guitarplayer-row.0ef12da8.png";